import { render } from "./PhoneDisplay.vue?vue&type=template&id=26437562"
import script from "./PhoneDisplay.vue?vue&type=script&lang=js"
export * from "./PhoneDisplay.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__